import { useState } from 'react';
import { Drawer } from '@/components/Drawer/Drawer';
import { EditAdminPersonalDetailsForm } from '@/bundle/_MasterAdmin/_OrganizationUserDetailsPage/ui/EditAdminPersonalDetailsForm';
import { InternalOrganizationUserType } from '../../types/types';
import { UserPersonalDetails } from '@/bundle/shared/components/UserDetails/UserPersonalDetails';
import { isInvitedOrganizationUser } from '@/helpers/organizationHelpers';

type AdminPersonalDetailsType = {
  user: InternalOrganizationUserType;
  onRefetchUser: () => void;
  isOwnAccount: boolean;
};

export const AdminPersonalDetails = ({ user, onRefetchUser, isOwnAccount }: AdminPersonalDetailsType) => {
  const [isEditOpen, setIsEditOpen] = useState(false);

  const openEdit = () => setIsEditOpen(true);

  const closeEdit = () => setIsEditOpen(false);

  const { first_name, middle_name, last_name, status } = user;
  const isInvited = isInvitedOrganizationUser(status);
  const personalDetails = {
    first_name,
    middle_name,
    last_name,
  };

  return (
    <>
      <UserPersonalDetails onEditOpen={openEdit} personalDetails={personalDetails} isEdit={isInvited || isOwnAccount} />
      <Drawer
        header='Edit Personal Information'
        subHeader='Please edit personal information.'
        isOpen={isEditOpen}
        onClose={closeEdit}
      >
        <EditAdminPersonalDetailsForm
          user={user}
          isOwnAccount={isOwnAccount}
          onSuccess={onRefetchUser}
          onClose={closeEdit}
        />
      </Drawer>
    </>
  );
};
